module.exports = __webpack_public_path__ + "img/voltage.06bee94d.png";